import heroBgField from '../fields/heroBgField';
import ctaField from '../fields/ctaField';

export default {
  value: 'hero_big_text',
  label: 'Hero with big text',
  fields: [
    {
      label: 'Pretitle',
      name: 'pretitle'
    },
    {
      label: 'Title',
      name: 'title'
    },
    {
      label: 'Subtitle',
      name: 'subtitle'
    },
    heroBgField,
    ctaField
  ]
};
